import { defineStore } from 'pinia'
import {deleteSession, getSessions, addSession, editSession} from '@/api/lists.js'

export const useSessionStore = defineStore('sessions', {
  state: () => ({
    sessionlist: []
  }),
  actions: {
    createSessionList(vm) {
      return new Promise((resolve, reject) => {
        getSessions({ vm }).then((sessions) => {
          this.sessionlist = sessions
          resolve('done')
        }).catch((resp) => {
          reject(resp)
        })
      })
    },
    addSession(session) {
      return new Promise((resolve, reject) => {
        addSession(session.session).then(() => {
          this.sessionlist.push(session.session)

          resolve('done')
        }).catch(err => reject(err))
      })
    },
    editSession(session) {
      return new Promise((resolve, reject) => {
        editSession(session).then(() => {
          const index = this.sessionlist.findIndex(eachsession => eachsession.id === session.id)
          this.sessionlist[index] = session
          // console.log('editsession', resp)
          resolve('done')
        }).catch(err => reject(err))
      })
    },
    deleteSession(session) {
      return new Promise((resolve, reject) => {
        deleteSession(session).then(() => {
          // console.log('deletesession', resp)
          this.sessionlist = this.sessionlist.filter(eachsession => eachsession.id !== session.id)
          resolve('done')
        }).catch(err => reject(err))
      })
    }
  }
})
